// Aurora Super Theme - WebGL aurora shader background - dark only
const auroraSuper = {
    id: "auroraSuper",
    name: "Revontulet 🌌",
    price: 200,
    main: "#7c4dff",
    light: "#b47cff",
    dark: "#3f1dcb",
    bg: "#0a0015",
    darkBg: "#05000a",
    isSuper: true,
    isDarkTheme: true,
    shape: "square",
    surfaces: {
        // Light mode (dark-only, fallback)
        lightBg: '#0a0015',
        lightPaper: '#1a1a2e',
        lightContainer: '#1a1a2e',
        lightOnSurface: '#f0f0f0',
        lightOnSurfaceVariant: '#b0b0cc',
        lightOutline: '#5050a0',
        // Dark mode
        containerLowest: '#10001e',
        containerLow: '#05000a',
        container: '#10001e',
        containerHigh: '#1a1a2e',
        containerHighest: '#242438',
        bright: '#2e2e48',
        onSurface: '#e8e0ff',
        onSurfaceVariant: '#a090c8',
        outline: '#5050a0',
        outlineVariant: '#303060',
        // Button colors — primary
        primaryContainer: '#b47cff',
        onPrimaryContainer: '#1a0040',
        // Button colors — secondary (outlined)
        secondaryContainer: '#1a1040',
        onSecondaryContainer: '#c8b0ff',
        // Button colors — secondary (filled)
        secondary: '#7cff67',
        onSecondary: '#003300',
        secondaryLight: '#3f1dcb',
        onSecondaryLight: '#ffffff',
        // Button colors — inverse
        inverseSurface: '#e8e0ff',
        onInverseSurface: '#05000a',
        inverseSurfaceLight: '#05000a',
        onInverseSurfaceLight: '#e8e0ff',
        // Button colors — label/text
        labelColor: '#7cff67',
        labelColorLight: '#7c4dff',
        // Status colors
        success: '#7cff67',
        successLight: '#a0ffa0',
        successDark: '#2e7d32',
        warning: '#ed6c02',
        warningLight: '#ff9800',
        warningDark: '#e65100',
        error: '#ef5350',
        errorLight: '#ff7961',
        errorDark: '#c62828',
    },
    animations: {
        avatar: "glowPulse",
        taskComplete: "profileEffect",
        completionGlow: true,
        buttonHover: "sparkle",
        profileEffect: {
            src: "/uploads/profile-effects/aurora-dreams/effect.json",
            width: 450,
            height: 880,
            scaleToCard: true,
        },
    },
    effects: {
        aurora: true,
        auroraColorStops: ["#5227FF", "#7cff67", "#5227FF"],
        auroraAmplitude: 1.0,
        auroraBlend: 0.5,
        auroraSpeed: 1.0,
        auroraOpacity: 0.8,
        glowColor: "#7cff6740",
    },
    modes: {
        light: {
            bg: "#0a0015",
            background: "linear-gradient(325deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
            cardBg: "rgba(20,20,35,0.6)",
            weeklyGoalBg: "rgba(20,20,35,0.85)",
            bonusCardBg: "rgba(20,20,35,0.6)",
            taskPendingText: "#ffffff",
            completedByOtherBg: "rgba(255,255,255,0.08)",
        },
        dark: {
            bg: "#05000a",
            background: "linear-gradient(325deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
            cardBg: "rgba(20,20,35,0.6)",
            weeklyGoalBg: "rgba(20,20,35,0.85)",
            bonusCardBg: "rgba(20,20,35,0.6)",
            taskPendingText: "#ffffff",
            completedByOtherBg: "rgba(255,255,255,0.08)",
        },
    },
};

export default auroraSuper;
